// import { NgxsDataPluginModule } from '@angular-ru/ngxs';
// import { provideHttpClient } from '@angular/common/http';
// import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject, isDevMode } from '@angular/core';
// import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
// import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
// import { provideAppCheck } from '@angular/fire/app-check';
// import { getAuth, provideAuth } from '@angular/fire/auth';
// import { getFirestore, provideFirestore } from '@angular/fire/firestore';
// import { getFunctions, provideFunctions } from '@angular/fire/functions';
// import { getMessaging, provideMessaging } from '@angular/fire/messaging';
// import { getPerformance, providePerformance } from '@angular/fire/performance';
// import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
// import { provideNativeDateAdapter } from '@angular/material/core';
// import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
// import { provideAnimations } from '@angular/platform-browser/animations';
// import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { provideRouter, withRouterConfig } from '@angular/router';
// import { provideServiceWorker } from '@angular/service-worker';
// import { provideTransloco, TranslocoService } from '@jsverse/transloco';
// import { NbAuthModule, NbTokenLocalStorage, NbTokenStorage } from '@nebular/auth';
// import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
// import { NbChatModule } from '@nebular/theme';
// import { provideStore } from '@ngxs/store';
// import { CapitalizePipe } from '@res/ng-capitalize';
// import { AngularProjectContext, FirebaseConfigToken } from '@res/ng-data-access';
// import {
//   ALL_THEMES as ALL_THEMES_TOKEN,
//   APP_CONFIG,
//   CheckForUpdateService,
//   CoreModule,
//   FCMState,
//   getAppCheck,
//   NB_CORE_PROVIDERS,
//   NbFirebasePasswordStrategy,
//   provideCookieConsent,
//   RemoteConfigService,
//   RemoteConfigState,
//   TranslocoHttpLoader,
//   UserState,
// } from '@res/ngg-core';
// import { ALL_THEMES, ThemeModule } from '@res/ngg-theme';
// import { InlineSVGModule } from 'ng-inline-svg-2';
// import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
// import { provideEcharts } from 'ngx-echarts';
// import { of } from 'rxjs';
// import { environment } from '../environments/environment';
// import { appRoutes } from './app.routes';
// import { PartnerState } from './data-access/store/partner/partner.state';
// import { RemoteConfigKey } from './remote-config.key';
// export class NbSimpleRoleProvider extends NbRoleProvider {
//   getRole() {
//     // here you could provide any role based on any auth flow
//     return of(['guest', 'customre', 'admin', 'support', 'francise partner']);
//   }
// }

// function appInitializerFactory() {
//   const configService = inject(RemoteConfigService);
//   return () => configService.initiateConfig();
// }

// // const Stores = [RentStore, LosserStore, VehicleStore, PartnerStore, UserStore];
// export const appConfig: ApplicationConfig = {
//   providers: [
//     { provide: APP_CONFIG, useValue: environment },
//     { provide: ALL_THEMES_TOKEN, useValue: ALL_THEMES },
//     { provide: FirebaseConfigToken, useValue: environment.firebaseConfig },
//     { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: environment.matOptions.formField },
//     provideRouter(appRoutes, withRouterConfig(environment.routerConfigOptions)),
//     provideAnimations(),
//     provideAnimationsAsync(),
//     provideNativeDateAdapter(),
//     provideEcharts(),
//     provideCharts(withDefaultRegisterables()),
//     // ...Stores,
//     // importProvidersFrom(),
//     provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
//     provideAppCheck(() => getAppCheck(environment.firebaseAppCheckKey, true, 'Entrprise')), //default
//     provideAuth(() => getAuth()),
//     provideFirestore(() => getFirestore()),
//     provideAnalytics(() => getAnalytics()),
//     provideFunctions(() => getFunctions()),
//     provideMessaging(() => getMessaging()),
//     providePerformance(() => getPerformance()),
//     provideRemoteConfig(() => getRemoteConfig()),
//     provideStore([PartnerState, UserState, FCMState, RemoteConfigState], ...environment.ngxsPlugins),
//     NbFirebasePasswordStrategy,
//     importProvidersFrom([
//       CoreModule.forRoot(),
//       NbChatModule.forRoot(environment.nbChatConfig),
//       NbAuthModule.forRoot({
//         strategies: [NbFirebasePasswordStrategy.setup(environment.coreConfig.authOptions.firebaseStrategieSetup)],
//         forms: environment.coreConfig.authOptions.forms,
//       }),
//       NbSecurityModule.forRoot(environment.coreConfig.securityOptions),
//       NgxsDataPluginModule.forRoot(),
//     ]),
//     importProvidersFrom(ThemeModule.forRoot()),
//     importProvidersFrom(InlineSVGModule.forRoot()),
//     provideHttpClient(),
//     { provide: NbRoleProvider, useClass: NbSimpleRoleProvider },
//     { provide: NbTokenStorage, useClass: NbTokenLocalStorage },
//     { provide: AngularProjectContext, useValue: { service: environment.serviceName, version: environment.version } },
//     provideTransloco({ config: environment.transloco, loader: TranslocoHttpLoader }),
//     NB_CORE_PROVIDERS,
//     ScreenTrackingService,
//     UserTrackingService,
//     CapitalizePipe,
//     TranslocoService,
//     CheckForUpdateService,
//     RemoteConfigService,
//     {
//       provide: APP_INITIALIZER,
//       useFactory: appInitializerFactory,
//       deps: [RemoteConfigService],
//       multi: true,
//     },
//     provideCookieConsent(RemoteConfigKey.cookieConsentConfig),
//     provideServiceWorker('ngsw-worker.js', { enabled: !isDevMode() }),
//     provideServiceWorker('firebase-messaging-sw.js', { enabled: !isDevMode() }),
//     // OriginHeaderRemoveInterceptor,
//   ],
// };

import { NgxsDataPluginModule } from '@angular-ru/ngxs';
import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject, Injector, isDevMode } from '@angular/core';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { FirebaseApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAppCheck } from '@angular/fire/app-check';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { NbAuthModule, NbAuthService, NbAuthToken, NbTokenLocalStorage, NbTokenStorage } from '@nebular/auth';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { NbChatModule } from '@nebular/theme';
import { provideStore } from '@ngxs/store';
import { CapitalizePipe } from '@res/ng-capitalize';
import { AngularProjectContext, FirebaseConfigToken } from '@res/ng-data-access';
import {
  ALL_THEMES as ALL_THEMES_TOKEN,
  APP_CONFIG,
  CoreModule,
  FCMState,
  getAppCheck,
  NbFirebasePasswordStrategy,
  provideCheckForUpdate,
  provideCookieConsent,
  provideNebularCore,
  RemoteConfigService,
  RemoteConfigState,
  TranslocoHttpLoader,
  UserState,
} from '@res/ngg-core';
import { ALL_THEMES, ThemeModule } from '@res/ngg-theme';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideEcharts } from 'ngx-echarts';
import { map, Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { PartnerState } from './data-access/store/partner/partner.state';
import { RemoteConfigKey } from './remote-config.key';
import { TransactionState } from './data-access/store/transaction/transaction.state';
import { RegistryState } from './data-access/store/registry/registry.state';
import { InvoiceState } from './data-access/store/invoice/invoice.state';
import { IssueState } from './data-access/store/issue/issue.state';
import { ServicingState } from './data-access/store/servicing/servicing.state';
import { OperatorState } from './data-access/store/operator/operator.state';
import { NotificationState } from './data-access/store/notification/notification.state';
import { NewPartnerWindowFormService } from './modal-overlays/window/window-form-new-partner/new-partner.service';

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return of(['guest', 'partner', 'admin', 'support', 'francise_partner']);
  }
}
/**
 * The slice of the Firebase ID token payload the shell needs. `admin` is the custom claim set by
 * tools/custom-claim-setter.js and is the only authority Firestore recognises (firestore.rules
 * isAdmin() reads request.auth.token.admin).
 */
type FirebaseIdTokenClaims = { admin?: boolean };

export class RoleProvider extends NbRoleProvider {
  private authService = inject(NbAuthService);
  getRole(): Observable<string> {
    return this.authService.onTokenChange().pipe(
      map((token: NbAuthToken) => {
        if (!token.isValid()) {
          return 'guest';
        }
        // Derive the Nebular role from the same claim firestore.rules enforces on. Anything else
        // (a 'role' claim, a profile document) lets the shell and the database disagree about who
        // is an admin, which shows UI the user's queries will then be denied.
        const claims: FirebaseIdTokenClaims | null = token.getPayload();
        return claims?.admin === true ? 'admin' : 'partner';
      }),
    );
  }
}

// Do not let a slow or blocked Remote Config fetch (e.g. App Check token acquisition failing on a
// preview / unconfigured domain) hang app bootstrap forever. Cap the wait so the UI still renders;
// Remote Config continues resolving in the background.
const REMOTE_CONFIG_BOOTSTRAP_TIMEOUT_MS = 8000;

export function appInitializerFactory() {
  const configService = inject(RemoteConfigService);
  return () => {
    // The timer has to be cleared on the happy path. APP_INITIALIZER runs inside the
    // Angular zone, so zone.js counts a live setTimeout as a pending macrotask and
    // ApplicationRef.whenStable() would not resolve until it fired, even when Remote
    // Config came back in 200ms. That matters here beyond tidiness: this app registers
    // ngsw-worker.js with registerWhenStable, so an uncleared timer delays service worker
    // registration by the full eight seconds on every otherwise-fast load.
    let bootstrapTimer: ReturnType<typeof setTimeout> | undefined;
    const timeout = new Promise<void>((resolve) => {
      bootstrapTimer = setTimeout(resolve, REMOTE_CONFIG_BOOTSTRAP_TIMEOUT_MS);
    });
    const loaded = configService
      .initiateConfig()
      .catch((error: unknown) => console.error('Remote Config failed to load; starting with defaults', error));

    return Promise.race([loaded, timeout]).finally(() => clearTimeout(bootstrapTimer));
  };
}

// const Stores = [RentStore, LosserStore, VehicleStore, PartnerStore, UserStore];

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_CONFIG, useValue: environment },
    { provide: ALL_THEMES_TOKEN, useValue: ALL_THEMES },
    { provide: FirebaseConfigToken, useValue: environment.firebaseConfig },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: environment.matOptions.formField },
    provideRouter(appRoutes, withRouterConfig(environment.routerConfigOptions)),
    provideAnimations(),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideEcharts(),
    provideCharts(withDefaultRegisterables()),
    // ...Stores,
    // importProvidersFrom(),
    // Resolve the App Check factory's Firebase app from DI (injector.get, not inject(): AngularFire
    // runs this factory inside runOutsideAngular where there is no active injection context). This
    // forces provideFirebaseApp to initialize the default app first AND yields the app on AngularFire's
    // own firebase instance (the one where the app-check component is registered), so initializeAppCheck
    // can hit neither the getApp() "No Firebase App '[DEFAULT]'" fallback nor "Component app-check has
    // not been registered yet" (which a raw firebase/app instance triggered).
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAppCheck((injector: Injector) =>
      getAppCheck(environment.firebaseAppCheckKey, true, 'Entrprise', injector.get(FirebaseApp)),
    ),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideAnalytics(() => getAnalytics()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    providePerformance(() => getPerformance()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideStore(
      [
        RemoteConfigState,
        FCMState,
        PartnerState,
        TransactionState,
        RegistryState,
        InvoiceState,
        IssueState,
        ServicingState,
        OperatorState,
        NotificationState,
        UserState,
      ],
      ...environment.ngxsPlugins,
    ),
    NewPartnerWindowFormService,
    importProvidersFrom([
      CoreModule.forRoot(),
      NbChatModule.forRoot(environment.nbChatConfig),
      NbAuthModule.forRoot({
        // Every data store in this app talks to Firestore through AngularFire, and firestore.rules
        // only sees a Firebase request.auth. Authenticating the shell against anything else lets a
        // user pass the route guards while every protected query is denied.
        strategies: [NbFirebasePasswordStrategy.setup(environment.coreConfig.authOptions.firebaseStrategyOptions)],
        forms: environment.coreConfig.authOptions.forms,
      }),
      NbSecurityModule.forRoot(environment.coreConfig.securityOptions),
      NgxsDataPluginModule.forRoot(),
    ]),
    importProvidersFrom(ThemeModule.forRoot(environment.nbThemeSettings)),
    importProvidersFrom(InlineSVGModule.forRoot()),
    provideHttpClient(),
    { provide: NbRoleProvider, useClass: RoleProvider },
    { provide: NbTokenStorage, useClass: NbTokenLocalStorage },
    { provide: AngularProjectContext, useValue: { service: environment.serviceName, version: environment.version } },
    provideTransloco({ config: environment.transloco, loader: TranslocoHttpLoader }),
    provideNebularCore(),
    NbFirebasePasswordStrategy,
    ScreenTrackingService,
    UserTrackingService,
    CapitalizePipe,
    TranslocoService,
    RemoteConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [RemoteConfigService],
      multi: true,
    },
    // provideRxDatabase(
    //   getRxDatabaseCreator({
    //     name: 'cash-link-crm',
    //     localDocuments: true,
    //     multiInstance: true,
    //     ignoreDuplicate: false,
    //     storage: getRxStorage(),
    //     plugins: [
    //       // will be loaded by together with core plugins
    //       RxDBDevModePlugin, // <- add only for development
    //       RxDBAttachmentsPlugin,
    //       RxDBLeaderElectionPlugin,
    //     ],
    //   })
    // ),
    provideCookieConsent(RemoteConfigKey.cookieConsentConfig),
    // Exactly one call. `provideServiceWorker` is not additive: it provides the script under a
    // single-valued token, so a second call left both registrations pointing at
    // firebase-messaging-sw.js, ngsw-worker.js was never registered, and the offline cache plus
    // SwUpdate/CheckForUpdateService went with it. The messaging worker does not belong here
    // anyway: getToken() registers /firebase-messaging-sw.js under its own
    // /firebase-cloud-messaging-push-scope, which is the scope FCMState looks it up by.
    provideServiceWorker('ngsw-worker.js', { enabled: !isDevMode() }),
    // Constructs CheckForUpdateService. Listing the class here, as this array used to, only
    // registered a factory nobody called, so the update watcher never ran.
    provideCheckForUpdate(),
    // OriginHeaderRemoveInterceptor,
  ],
};
